import {
  Identifiable,
  RetrieveZonesIndicatorsFilter,
  Sort,
  ZoneIndicators,
  zoneIndicators,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  zones: Identifiable<ZoneIndicators>[];
};

function getZonesIndicators(httpClient: HttpClient) {
  return (
    filter: RetrieveZonesIndicatorsFilter,
    sort: Sort,
    view: "simple" | "indicators",
    size: number,
    index: number,
  ) => {
    const sortMap: { [key in Sort]: string[] } = {
      ascendingName: ["ascending", "name"],
      ascendingStartDate: ["ascending", "start"],
      ascendingEndDate: ["ascending", "end"],
      ascendingCompletionDate: ["ascending", "completionDate"],
      ascendingCreationDate: ["ascending", "creation"],
      ascendingRank: ["ascending", "rank"],
      descendingName: ["descending", "name"],
      descendingStartDate: ["descending", "start"],
      descendingEndDate: ["descending", "end"],
      descendingCompletionDate: ["descending", "completionDate"],
      descendingCreationDate: ["descending", "creation"],
      descendingRank: ["descending", "rank"],
      ascendingAuthor: ["", ""],
      descendingAuthor: ["", ""],
    };
    const [sortOrder, sortType] = sortMap[sort] || sortMap.ascendingName;

    const includedOrganizationalUnits = (filter.organizationalUnits ?? [])
      .filter(({ isExcluded }) => !isExcluded)
      .map(({ uuid }) => uuid);
    const excludedOrganizationalUnits = (filter.organizationalUnits ?? [])
      .filter(({ isExcluded }) => isExcluded)
      .map(({ uuid }) => uuid);

    return httpClient
      .sendHttpRequest<Response>({
        endpoint: `/zones/get-filtered-and-sorted-list`,
        method: HttpMethods.POST,
        data: {
          sortType,
          sortOrder,
          zones: filter.zones ? filter.zones.map(({ uuid }) => uuid) : [],
          statuses: filter.projectStatuses
            ? filter.projectStatuses.map(({ uuid }) => uuid)
            : [],
          projects: filter.projects
            ? filter.projects.map(({ uuid }) => uuid)
            : [],
          projectPortfolios: filter.projectPortfolios
            ? filter.projectPortfolios.flatMap((portfolio) =>
                portfolio.projects.map(({ uuid }) => uuid),
              )
            : [],
          tags: filter.projectsTags
            ? filter.projectsTags.map(({ name }) => name)
            : [],
          resources: filter.resources
            ? filter.resources.map(({ uuid }) => uuid)
            : [],
          roles: filter.roles ? filter.roles.map(({ uuid }) => uuid) : [],
          organizationalUnits: includedOrganizationalUnits,
          excludedOrganizationalUnits: includedOrganizationalUnits.length
            ? excludedOrganizationalUnits
            : [],
          includeAllZones: filter.includeAllZones ?? false,
          options: {
            type: view === "indicators" ? "details" : "simple",
            size,
            page: index,
          },
        },
      })
      .then(({ zones }) =>
        zones
          ? zones
              .filter(({ savingTemplates }) => !savingTemplates)
              .map((z) => ({
                ...zoneIndicators,
                ...z,
                color: z.color ? z.color : "#000000",
                description: "description" in z ? z.description : "",
              }))
          : [],
      )
      .catch((e) => Promise.reject({ ...e, message: e.details || "" }));
  };
}

export { getZonesIndicators };
